import './components/btn-up.js';
import './components/img-click.js';
